import React from 'react';
import { Navigate } from 'react-router-dom';
import urls from 'routes/urls';
import { useFetchUserData } from 'queries/auth/user';
import LoadingComponent from 'components/shared/Loading';
import { clearAuthSession } from 'utils/auth';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  const isSuperAdminLocal = localStorage.getItem('isSuperAdmin') === 'true';
  const accessToken = localStorage.getItem('accessToken');
  const { userData, isLoading } = useFetchUserData();

  if (!accessToken || !isSuperAdminLocal) {
    // Redirect to super admin login if not authenticated or not an admin
    clearAuthSession();
    return <Navigate to={urls.superAdminLogin} replace />;
  }

  // Wait for loading to finish
  if (isLoading) {
    return <LoadingComponent />; 
  }

  // Once data is loaded, verify strictly against backend-provided flag
  // If userData is an empty array or null, it's not a valid super admin session
  const hasSuperAdminRights = userData && !Array.isArray(userData) && userData.is_super_admin === true;

  if (!hasSuperAdminRights) {
     clearAuthSession();
     // Only redirect to login if we are absolutely sure they don't have rights
     return <Navigate to={urls.superAdminLogin} replace />;
  }

  return <>{children}</>;
};

export default SuperAdminRoute;
